// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__ByNGh","actions":"styles_actions__65EaV","actions_btn":"styles_actions_btn__Miia7"};